module.exports = __webpack_public_path__ + "img/Selection.3438e485.svg";